import React from 'react';

export default function ThankyouPage(props){
    const userFirstName = props.userObj.details.firstName;
    return(
        <div className="thankyou-container">
            <div className="header-title">
                <div className="header-light">{props.translations.data["THANKYOU.TEXT"]}, <span className="userName">{userFirstName}!</span></div>
                <div className="header-bold">{props.translations.data["THANKYOU.SUB_TEXT"]}</div>
                <div className="header-light">{props.translations.data["THANKYOU.CLOSE_MESSAGE"]}</div>
            </div>
        </div>
    )
}